import {all} from 'redux-saga/effects';
import authSagas from './Auth';
import customerSagas from './Customer';
import userSagas from './Users';
import complianceSagas from './Compliance'
import insiderSagas from './Insider'
import miscSagas from './Misc'
import breachriskSagas from './BreachRisk'
import commonSagas from './Common';
import adminSagas from './Admin';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    customerSagas(),
      userSagas(),
      complianceSagas(),
      insiderSagas(),
    miscSagas(),
    breachriskSagas(),
    commonSagas(),
      adminSagas(),
  ]);
}
